import { getRequest } from '@/core';
import { users } from '@/requests';

export default async function getCurrentClerkRequest() {
	let url = users.getCurrentClerk();
	let response = await getRequest(url);
	return response;
}
